export function isVariantKey(key: string): boolean {
  return /^[0-9a-z]{2,}(-(\*|[0-9a-z]{1,}))*$/i.test(key)
}
